import CloseIcon from "@mui/icons-material/Close";
import * as React from "react";

import styles from "./EarlyAccessBanner.module.css";

const EARLY_ACCESS_BANNER_DISMISSED_KEY = "chat_early_access_banner_dismissed";

export const EarlyAccessBanner = () => {
  const [dismissed, setDismissed] = React.useState(() => {
    return sessionStorage.getItem(EARLY_ACCESS_BANNER_DISMISSED_KEY) === "true";
  });

  const handleDismiss = () => {
    sessionStorage.setItem(EARLY_ACCESS_BANNER_DISMISSED_KEY, "true");
    setDismissed(true);
  };

  if (dismissed) {
    return null;
  }

  return (
    <div className={styles.banner}>
      <span className={styles.text}>
        🚀 Early Access — mouse over the info icon above for details!
      </span>
      <button
        className={styles.dismissButton}
        onClick={handleDismiss}
        aria-label="Dismiss banner"
      >
        <CloseIcon className={styles.dismissIcon} />
      </button>
    </div>
  );
};
